import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const MANCHI_TOKEN_KEY = "manchi_token";

export const manchiApi = axios.create({ baseURL: `${BACKEND_URL}/api/manchi` });

manchiApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(MANCHI_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const manchiAuth = {
  saveToken(t) { localStorage.setItem(MANCHI_TOKEN_KEY, t); },
  getToken() { return localStorage.getItem(MANCHI_TOKEN_KEY); },
  clear() { localStorage.removeItem(MANCHI_TOKEN_KEY); },
};
